import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const create = async (datos) => {
  return await axiosIns.post(obtenerUrl('comprobantes-reversiones'), datos);
};

const obtenerPorId = async (id) => {
  return await axiosIns.get(obtenerUrl(`comprobantes-reversiones/${id}`));
};

export default {
  create,
  obtenerPorId,
};
